// extracted by mini-css-extract-plugin
module.exports = {"iconscity":"City_iconscity__22l_5","scorecity":"City_scorecity__2UxZc"};